import { Resource } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { AssignmentsDto } from '../../../../../../interfaces/dtos/AssignmentsDto';
import getApiRoot from '../../../../../../utils/getApiRoot';
import transformAssignments from './transformAssignments';

export interface AssignmentsLoaderProps { mailSubjectId: number }

const AssignmentsLoader: FC<AssignmentsLoaderProps> = ({ mailSubjectId }) => {
  const url = useMemo(() => `${getApiRoot()}/settings/subjectAssignments?subjectId=${mailSubjectId}`, [mailSubjectId]);
  return (
    mailSubjectId ?
      <Resource
        autoRequest
        name="/App.features.securedMessaging.new.subjectAssignmentsResource"
        url={url}
        dataDst="subjectAssignments"
        transformResponse={({ data }: { data: AssignmentsDto[] }) => transformAssignments(data)}
      /> : null

  );
};
export default AssignmentsLoader;
